import {
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllSlideAction,
  createSlideAction,
  deleteSlideAction,
  updateSlideAction,
} from "../../../redux/actions/SlideAction";
import { baseUrlImg } from "../../../Api/baseUrl";

const SliderAdmin = () => {
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const [imgg, setimgg] = useState("");
  const [slideid, setslideid] = useState("");
  const [ISedit, setISedit] = useState(false);
  const [Titlee, setTitlee] = useState("");
  const [SubTitle, setSubTitle] = useState("");

  const [Deletesow, setDeletesow] = useState(false);
  const handleCloseDelete = () => setDeletesow(false);
  const handleShowDelete = (item) => {
    setDeletesow(true);
    setslideid(item.id);
  };
  const splitImage=(URL)=>{
    const pathSegments = URL.split('media/');
    const lastSegment = '/media/'+pathSegments[pathSegments.length - 1];
    return lastSegment
  }
  const All = useSelector((state) => state.SlideReduser.GetallSlide);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllSlideAction());
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Titlee === "" || imgg === "" || SubTitle === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("title", Titlee);
    formData.append("image", imgg);
    formData.append("subtitle", SubTitle);

    await dispatch(createSlideAction(formData));
    setTitlee("");
    setimgg("");
    setLoading(false);
    setSubTitle("");
    setisPress(false);
  };
  const handlesubmitUpdate = async (e) => {
    e.preventDefault();
    if (Titlee === "" || SubTitle === "" || imgg === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("title", Titlee);
    formData.append("image", imgg);
    formData.append("subtitle", SubTitle);
    formData.append("setting_id", slideid);
    await dispatch(updateSlideAction(formData));
    setLoading(false);
    setisPress(false);
    setSubTitle("");
    setISedit(false);
    setTitlee("");
    setimgg("");
    setslideid("");
  };
  const update = (item) => {
    setISedit(true);
    setTitlee(item.title);
    setslideid(item.id);
    setSubTitle(item.subtitle);
    setimgg(splitImage(item.image_url));
  };
  const res = useSelector((state) => state.SlideReduser.createSlide);
  const Update = useSelector((state) => state.SlideReduser.UpdateSlide);
  const Del = useSelector((state) => state.SlideReduser.deleteSlide);
  const handleDelete = async () => {
    setisPress(true);

    await dispatch(
      deleteSlideAction({
        setting_id: slideid,
      })
    );
    setDeletesow(false);
    setLoading(false);
    setisPress(false);
    setslideid("");
  };
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            dispatch(GetAllSlideAction());
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
            dispatch(GetAllSlideAction());
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllSlideAction());
          }
        }
      }

      if (Update) {
        if (Update.status === 200 || Update.status === 201) {
          if (Update.data) {
            notify(Update.data.message, "success");
            dispatch(GetAllSlideAction());
          }
        } else if (Update.status !== 200 || Update.status !== 201) {
          if (Update.data) {
            notify(Update.data.message, "error");
            dispatch(GetAllSlideAction());
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllSlideAction());
          }
        }
      }

      if (Del) {
        if (Del.status === 200 || Del.status === 201) {
          if (Del.data) {
            notify(Del.data.message, "success");
            dispatch(GetAllSlideAction());
          }
        } else if (Del.status !== 200 || Del.status !== 201) {
          if (Del.data) {
            notify(Del.data.message, "error");
            dispatch(GetAllSlideAction());
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllSlideAction());
          }
        }
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <h4 className="text-center mt-3 mb-3">إدارة الأعلانات </h4>
        <div className="inputs-container">
          <div className="inp-container ">
            <TextField
              focused
              label={
                <Typography>
                  الصورة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              onChange={(e) => setimgg(e.target.files[0])}
              variant="outlined"
              // disabled={ISedit}
              type="file"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  العنوان
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="text"
              value={Titlee}
              onChange={(e) => setTitlee(e.target.value)}
              variant="outlined"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  عنوان فرعي
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="text"
              value={SubTitle}
              onChange={(e) => setSubTitle(e.target.value)}
              variant="outlined"
            />
          </div>
          <div className="inp-container "></div>

          <div className="inp-container "></div>
        </div>
        {loading && isPress ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : ISedit ? (
          <button className="buttonadd" onClick={handlesubmitUpdate}>
            تعديل
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            إضافة
          </button>
        )}
        <hr />
        <Table className="maint" responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                الصورة <i className="fa-solid fa-user"></i>
              </th>
              <th>
                العنوان <i className="fa-solid fa-address-card"></i>
              </th>
              <th>
                العنوان الفرعي <i className="fa-solid fa-address-card"></i>
              </th>

              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {All && All.length >= 0
              ? All.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <img
                        src={baseUrlImg + splitImage(item.image_url)}
                        style={{ width: "70px" }}
                        alt=""
                      />
                    </td>
                    <td>{item.title}</td>

                    <td>{item.subtitle}</td>
                    <td className="icon-w">
                      <i
                        onClick={() => update(item)}
                        className="fa fa-solid fa-pen-to-square"
                        style={{ color: "rgb(0 44 146)" }}
                      ></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShowDelete(item)}
                        className="fs fa-solid fa-trash-can"
                        style={{ color: "red" }}
                      ></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <ToastContainer />
      </Container>
      <Modal
        show={Deletesow}
        onHide={handleCloseDelete}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>هل تريد حذف العنصر</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          {" "}
          <Addcategory />{" "}
        </Modal.Body> */}

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDelete}
          >
            إغلاق
          </Button>
          <Button variant="secondary" className="close" onClick={handleDelete}>
            موافق
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SliderAdmin;
